import { Component, OnInit } from '@angular/core';
import { NotificationsCenterService } from '@core/services/notifications-center.service';
import { NotificationType, UserNotificationItem } from '@shared/models';
import { Observable } from 'rxjs';

@Component({
  selector: 'gcc-notifications-center',
  templateUrl: './notifications-center.component.html',
  styleUrls: ['./notifications-center.component.scss'],
  standalone: false
})
export class NotificationsCenterComponent implements OnInit {
  public notifications$: Observable<UserNotificationItem[]>;
  public notificationType = NotificationType;
  public isOpen = false;

  constructor(private notificationCenter: NotificationsCenterService) {}

  public ngOnInit(): void {
    this.notifications$ = this.notificationCenter.notificationsForCenter$;
  }

  public onDropdownOpen(isOpen: boolean) {
    this.isOpen = isOpen;
    if (!this.isOpen) {
      this.notificationCenter.clearRecentlyDeleted();
      document.body.style.overflowY = 'auto';
    } else {
      document.body.style.overflowY = 'hidden';
    }
  }

  public handleDelete(id: string) {
    this.notificationCenter.dismissFromCenter(id);
  }

  public trackById(_, item: UserNotificationItem) {
    return item.notificationId;
  }

  public handleDeleteAll() {
    this.notificationCenter.dismissFromCenterAll();
  }

  public handleCancelDelete(id: string) {
    this.notificationCenter.undoDismissFromCenter(id);
  }
}
